import { Link } from '@tanstack/react-router'
import type { BundlePickerTier, Product } from '#bv/data/products'
import { BundleTierList } from '#bv/components/BundleTierList'

type Props = {
  familyName: string
  hubId: number
  pickerTitle: string
  tiers: BundlePickerTier[]
  catalog: Product[]
  currentProductId: number
  inStock: (productId: number) => boolean
  /** Tighter block inside product checkout layout. */
  embedded?: boolean
}

export function FamilyTierLinks({
  familyName,
  hubId,
  pickerTitle,
  tiers,
  catalog,
  currentProductId,
  inStock,
  embedded,
}: Props) {
  const others = tiers.filter((t) => t.productId !== currentProductId)
  if (others.length === 0) return null

  return (
    <div
      className={
        embedded
          ? ''
          : 'mx-auto mt-12 max-w-3xl border-t border-white/[0.07] pt-10 lg:mt-14 lg:pt-12'
      }
    >
      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="m-0 text-[0.6rem] font-bold uppercase tracking-[0.18em] text-[#5a6d8a]">Same family</p>
          <h2 className="font-display mt-1.5 text-xl tracking-wide text-[#f0f6ff] sm:text-2xl">
            Other {familyName} tiers
          </h2>
          <p className="mt-1.5 text-xs leading-relaxed text-[#5a6d8a] sm:text-sm">{pickerTitle}</p>
        </div>
        <Link
          to="/products/$productId"
          params={{ productId: String(hubId) }}
          className="shrink-0 text-xs font-semibold text-[#93c5fd] transition-colors hover:text-[#7ec8ff]"
        >
          Compare all tiers →
        </Link>
      </div>

      <BundleTierList tiers={others} catalog={catalog} inStock={inStock} layout="list" />
    </div>
  )
}
